import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import WaitingAreaCallerEntryPointContent from '../components/pages/waiting-area/caller-entry/content';

function WaitingAreaCallerEntryPointPage(props) {
  const showCallerEntryModal = useSelector((state) => state.modalReducer.showCallerEntryModal);
  const callerEntryPointForm = useSelector((state) => state.waitingAreaReducer.callerEntryPointForm);
  const messageData = useSelector((state) => state.globalMessageReducer.messageData);

  const dispatch = useDispatch();

  return (
    <div>
      <WaitingAreaCallerEntryPointContent
        waitingArea={props.waitingArea}
        callerEntryPointForm={callerEntryPointForm}
        showCallerEntryModal={showCallerEntryModal}
        updateOrView={props.updateOrView}
        dispatch={dispatch}
        messageData={messageData}
      />
    </div>
  );
}
export default WaitingAreaCallerEntryPointPage;
